import {
    Row, Col, Button, Modal, Flex, List
} from 'antd';

import React from "react";
import { useTranslation } from "react-i18next";
import ExpandableText from '../../components/data/ExpandableText';
import DataCard from '../../components/data/DataCard';
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";


const RecallsCardView = ({vehicle, isViewRecallModalVisible, setIsViewRecallModalVisible, maintenanceRecalls, setNavigatedFromRecalls, clickCreateNewRequestButton, loadingProgress}) => {
  const { t } = useTranslation();
    const { isOnline } = useOnlineStatus();

  function RecallCardView({recalls}) {
    return (
            (recalls && recalls.length > 0)
            ?
            <div style={{height: 350,overflow: 'auto',}}>
             <Flex vertical>
               <List>
                 {recalls.map(recall => (
                  <List.Item key={recall.id}>
                    <DataCard
                          title={recall.recallReference}
                    >
                      <Row gutter="16" style={{width: '100%'}}>
                        <Col span={6}> {recall.launchDate} </Col>
                        <Col span={12}><ExpandableText rows={2} text={recall.description}/></Col>
                        <Col span={6}>  {recall.recallStatus}  </Col> 
                      </Row>
                    </DataCard>                
                  </List.Item>
                 ))}
               </List>
             </Flex>
            </div>
            :
            <div></div>
           )
  }     

return (
        <Modal className="std-portal-popup dp-wrap-card-title" 
               open={isViewRecallModalVisible && maintenanceRecalls}
               title={t('title.recalls')}
               closable={true}
               keyboard={true}
               footer={
                        isOnline
                        ?
                        [
                          <Button type="primary" 
                                  loading={loadingProgress !== 100 && !vehicle} 
                                  onClick={(e) => {
                                    setIsViewRecallModalVisible(false); 
                                    setNavigatedFromRecalls(true);
                                    clickCreateNewRequestButton(e);
                                  }}
                          >
                            {t('title.booking_requests')}
                          </Button>
                        ]
                        :
                        <></>
                      }
               onCancel={() => {
                setIsViewRecallModalVisible(false);
              }}
        >
          <RecallCardView recalls={maintenanceRecalls}/>
        </Modal>
       );
}

export default RecallsCardView;